/*
 * Created Date: 08-12-2021, 10:51:30 am
 * Author: DinhNC
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2021 EDUFIT GROUP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

// import { parseTime } from '@Core/Helpers/Date'
import { formatDate } from '@Core/Helpers/String'
import { TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker'
import PropTypes from 'prop-types'
import React from 'react'
import { Controller } from 'react-hook-form'
import vi from 'date-fns/locale/vi'

const CoreTimePicker = ({ control, name, label, inputProps, className, required, onlyTime, ...props }) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={vi}>
			<div className={className}>
				<Controller
					control={control}
					name={name}
					render={({ field: { onChange, value }, fieldState: { error, invalid } }) => (
						<MuiTimePicker
							label={label}
							// value={isValid(new Date(value)) ? value : parseTime(value)}
							value={new Date(value)}
							onChange={val => {
								if (onlyTime) {
									onChange(formatDate(val, 'HH:mm:ss'))
								} else {
									onChange(val)
								}
							}}
							ampm={false}
							renderInput={params => (
								<TextField
									fullWidth
									className="flex-shrink-0 min-w-96"
									InputLabelProps={{
										...params.InputLabelProps,
										required
									}}
									{...params}
									{...inputProps}
									error={invalid}
									helperText={error?.message}
								/>
							)}
							{...props}
						/>
					)}
				/>
			</div>
		</LocalizationProvider>
	)
}

CoreTimePicker.propTypes = {
	control: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	disabled: PropTypes.bool,
	onlyTime: PropTypes.bool
}

export default React.memo(CoreTimePicker)
